import {connect} from "react-redux";
import JobToCandidatesBreadcrumbs from "~/components/JobToCandidatesBreadcrumbs";

function mapStateToProps(state) {
    return {
        furthestStep: state.jobToCandidates.furthestStep,
    };
}

const mapDispatchToProps = {
    //
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(JobToCandidatesBreadcrumbs);
